import { buildModelManager } from "../builder.js";
const DefaultTemplateAssetSelection = {
  __typename: true,
  id: true,
  bunnyKey: true,
  byteSize: true,
  campaignId: true,
  cdnUrl: true,
  createdAt: true,
  deletedAt: true,
  elementType: true,
  elementUid: true,
  file: { url: true, mimeType: true, fileName: true },
  isActive: true,
  shopId: true,
  storageProvider: true,
  updatedAt: true,
  uploadState: true
};
const modelApiIdentifier = "template_asset";
const pluralModelApiIdentifier = "template_assets";
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultTemplateAssetSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createTemplateAsset",
    operationReturnType: "CreateTemplateAsset",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      template_asset: { required: false, type: "CreateTemplateAssetInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultTemplateAssetSelection
  },
  {
    type: "action",
    operationName: "bulkCreateTemplateAssets",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateTemplateAssetsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultTemplateAssetSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "template_assetGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const TemplateAssetManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultTemplateAssetSelection,
  operations
);
export {
  DefaultTemplateAssetSelection,
  TemplateAssetManager
};
//# sourceMappingURL=TemplateAsset.js.map
